module.exports = __webpack_public_path__ + "static/FBA-45267e999be9f5b1e34c463b4e809fbe.png";